import Store from 'lightningjs-redux';
import {
  getIsLive,
  getTitle,
  getExtraTitle,
  isLiveSeekEnabled,
  getLBannerState,
} from '../../../../logic/player/player.selectors';
import { getCurrentVideoItem, getCurrentChapter } from '../../../../logic/player/video.selectors';

const mapControllers = instance => [
  {
    selector: getIsLive,
    callback: value => {
      instance.isLive = value;
    },
  },
  {
    selector: isLiveSeekEnabled,
    callback: value => {
      instance.isLiveSeekEnabled = value;
    },
  },
  {
    selector: getTitle,
    callback: value => {
      instance.title = value;
    },
  },
  {
    selector: getExtraTitle,
    callback: value => {
      instance.extraTitle = value;
    },
  },
  {
    selector: getCurrentVideoItem,
    callback: value => {
      instance.programInformation = value;
    },
  },
  {
    selector: getCurrentChapter,
    callback: value => {
      instance.chapter = value;
    },
  },
  {
    selector: getLBannerState,
    callback: value => {
      instance.lBannerState = value;
    },
  },
];

export default Store.control(mapControllers);
